import { LogOut } from 'lucide-react'
import logoUrl from '../assets/logo.webp'
import type { Ik } from '../../gedeeld/types'

/**
 * De balk bovenaan.
 *
 * Het logo is ook de weg terug naar het overzicht. Dat is niet uit te leggen
 * aan wie het niet al weet -- vandaar dat er ook een gewone terugknop in het
 * lesscherm staat. Dit is de snelle weg voor wie hem kent, niet de enige.
 */
export default function Balk({
  ik, opNaarHuis, opAfmelden,
}: {
  ik: Ik | null
  opNaarHuis: () => void
  opAfmelden: () => void
}) {
  return (
    <header className="balk">
      <div className="balk-in">
        <button className="merk" onClick={opNaarHuis} title="Naar het overzicht">
          {/* Op een donker plaatje: het merkbestand is voor een donkere
              ondergrond getekend en verdwijnt op wit. Zie app.css. */}
          <span className="plaat">
            <img src={logoUrl} alt="Truckwash1 Group" width={116} height={32} draggable={false} />
          </span>
          <span className="woord">Academy</span>
        </button>

        <div className="rek" />

        {ik && (
          <>
            <div className="wie">
              <span className="bol">{letters(ik.naam)}</span>
              {/* Op een smal scherm valt de naam weg en blijft de bol staan.
                  Een naam die afbreekt is lelijker dan geen naam. */}
              <span className="alleen-breed">{ik.naam}</span>
            </div>
            <button className="knop kaal" onClick={opAfmelden} title="Afmelden">
              <LogOut size={17} />
            </button>
          </>
        )}
      </div>
    </header>
  )
}

/** De eerste letter van de voornaam en van het laatste woord. */
function letters(naam: string): string {
  const delen = naam.trim().split(/\s+/).filter(Boolean)
  if (delen.length === 0) return '?'
  if (delen.length === 1) return (delen[0] ?? '?').slice(0, 1).toUpperCase()
  return ((delen[0] ?? '').slice(0, 1) + (delen[delen.length - 1] ?? '').slice(0, 1)).toUpperCase()
}
